module.exports = __webpack_public_path__ + "img/Logo-glava.45350429.svg";